import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  container: {
    overflowX: 'auto',
    scrollbarWidth: 'thin',
    background: 'var(--ui-header-mega-menu-background-color)',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    borderBottomColor: 'var(--ui-header-mega-menu-border-bottom-color)',
    borderBottomStyle: 'var(--ui-header-mega-menu-border-bottom-style)',
    borderBottomWidth: 'var(--ui-header-mega-menu-border-bottom-width)',
  },
  activeIndicator: {
    color: 'var(--ui-header-mega-menu-item-active-text-color)',
    '&:after': {
      content: '""',
      backgroundColor: 'var(--ui-header-mega-menu-item-active-color)',
      position: 'absolute',
      bottom: 0,
      left: 'var(--ui-header-mega-menu-item-indicator-left)',
      right: 'var(--ui-header-mega-menu-item-indicator-right)',
      top: 'var(--ui-header-mega-menu-item-indicator-top)',
    },
  },
  menu: {
    width: 'fit-content',
    position: 'relative',
    margin: 'var(--ui-header-mega-menu-margin)',
    padding: '0 var(--ui-spacer-s)',
    display: 'flex',
    listStyleType: 'none',
    alignItems: 'center',
    justifyContent: 'var(--ui-header-mega-menu-justify-content)',
    minWidth: 'var(--ui-header-mega-menu-min-width)',
  },
  menuItem: {
    padding: '0 var(--ui-spacer-m)',
    // height: '3.5rem',
    fontSize: '1.4rem',
    margin: 0,
    whiteSpace: 'nowrap',
  },
  menuItemLink: {
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'var(--ui-header-mega-menu-item-text-color)',
    fontWeight: 'var(--ui-header-mega-menu-item-font-weight)',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    display: 'block',
    position: 'relative',
    '&:hover': {
      extend: 'activeIndicator',
    },
    '& p': {
      textTransform: 'lowercase',
      fontSize: 14,
      color: theme.colors.primary,
      '&:hover': {
        color: theme.colors.secondary,
      },
    },
  },
  active: {
    extend: 'activeIndicator',
  },
  menuItemLinkText: {
    position: 'relative',
    zIndex: 2,
  },
}))

export default useStyles
